import { useState } from "react";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
function useApiGet() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const Getdata = (url, auth) => {
        setLoading(true);
        setError(null);
        // console.log("Hello");
        // console.log(data)
        // console.log("Hello");
        let token = `Bearer ${localStorage.getItem('ACCESS')}`
        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": auth ? token : "",
            },
        })
            .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
            .then((result) => {
                // console.log("resulyt")
                // console.log(result)
                // console.log("resulyt")
                setData({...result});

                if (result.status === 200) {
                }
                if (result.status === 401 || result.status === 403) {
                   
                }
                if (result.status === 400) {

                }
                if (result.status === 405) {

                }

                if (result.status === 500) {

                }
            })
            .catch((err) => {
                // console.error(err,"ertyui")
                toast.warning('Something went wrong, Try again', {
                    position: "top-center",
                  });
                toast.clearWaitingQueue();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return { data, loading, error, Getdata, setData, setLoading, setError };
}

export default useApiGet;
